import { AxiosError, AxiosResponse } from 'axios'
import { FormikBag } from 'formik'

import { handleErrResponse, transformErrorsForForm } from '.'
import { apiRequest } from './Request'

export type HTTPMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'
export type FormHTTPMethod = 'POST' | 'PUT'

interface HandleApiOptions<P, V> {
  url: string
  method?: HTTPMethod
  values: V
  bag?: FormikBag<P, V>
  config?: any
  onSuccess?: (response: AxiosResponse<{}>) => void
  onError?: (response: AxiosError) => void
}
export const handleApiCall = async <P, V>(options: HandleApiOptions<P, V>) => {
  if (options.bag) {
    options.bag.setSubmitting(true)
  }
  const method = options.method || 'POST'

  if (method === 'POST') {
    try {
      const res = await apiRequest.post(
        options.url,
        options.values,
        options.config,
      )
      options.onSuccess && options.onSuccess(res)
    } catch (err) {
      processErrResponse(err, options)
    }
  }
  if (method === 'PUT') {
    try {
      const res = await apiRequest.put(options.url, options.values)
      options.onSuccess && options.onSuccess(res)
    } catch (err) {
      processErrResponse(err, options)
    }
  }
  if (method === 'GET') {
    try {
      const res = await apiRequest.get(options.url)
      options.onSuccess && options.onSuccess(res)
    } catch (err) {
      processErrResponse(err, options)
    }
  }
  if (options.bag) {
    options.bag.setSubmitting(false)
  }
}

export const processErrResponse = (err, options) => {
  const errors = handleErrResponse(err)

  const errorsT = transformErrorsForForm(errors)
  // console.log(errors, errorsT)
  if (errorsT) {
    if (options.bag) {
      options.bag.setErrors(errorsT)
      // przewińmy stronę na górę, TODO przewińmy stronę do elementu który ma error
      window.scrollTo(0, 0)
    }
  }
  if (options.bag) {
    options.bag.setSubmitting(false)
  }

  options.onError && options.onError(err)
}
